import { LOCALE_ID, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { Router } from "@angular/router";
import { OVERLAY_DEFAULT_CONFIG } from "@angular/cdk/overlay";
import { ApplicationInsightsService } from "./application-insights.service";

import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NavModule } from "./nav/nav.module";
import {
  AlertDialogComponent,
  ConfirmationDialogComponent,
  VersionDialogComponent,
} from "./shared/services/notification.service";
import { AppMatModule } from "./shared/app-mat.module";
import { AppRoutingModule } from "./app-routing.module";
import { AuthModule } from "./auth/auth.module";
import {
  AzureLoggerService,
  LoggerService,
} from "./shared/services/logger.service";
import { AuthInterceptor } from "./auth/auth.interceptor";
import { ValidationInterceptor } from "./shared/interceptors/validation.interceptor";
import { NeedsPermissionModule } from "./auth/permissions";
import { AutoLogoutComponent } from "./auto-logout/auto-logout.component";
import { SchoolYearInterceptor } from "./shared/interceptors/schoolyear.interceptor";
import { SurveyModule } from "./shared/survey/survey.module";
import { SurveysModule } from "./surveys/surveys.module";
import { PublicModule } from "./public/public.module";
import { InputsModule } from '@progress/kendo-angular-inputs';
import 'hammerjs';
import { GridModule } from '@progress/kendo-angular-grid';
import { DragDropModule} from '@angular/cdk/drag-drop';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DragAndDropModule } from '@progress/kendo-angular-utils';
import { SpreadsheetModule } from '@progress/kendo-angular-spreadsheet';
import { NotificationModule } from "@progress/kendo-angular-notification";
import { DatePipe } from "@angular/common";
import { SharedModule } from "./shared/shared.module";

@NgModule({
    declarations: [
        AppComponent,
        AlertDialogComponent,
        ConfirmationDialogComponent,
        VersionDialogComponent,
        AutoLogoutComponent,
    ],
    imports: [
        AuthModule,
        HttpClientModule,
        FormsModule,
        NavModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        AppMatModule,
        NeedsPermissionModule,
        ReactiveFormsModule,
        SurveyModule,
        SurveysModule,
        PublicModule,
        InputsModule,
        GridModule,
        DragDropModule,
        ButtonsModule,
        DragAndDropModule,
        SpreadsheetModule,
        NotificationModule,
        SharedModule
    ],
    providers: [
        { provide: DatePipe },
        // Angular CDK 21 defaults to using the HTML Popover API for overlays,
        // which renders dialogs in the browser top layer above all other DOM
        // content regardless of z-index. This hides the global spinner overlay
        // and breaks Kendo popups (datepicker, dropdown) opened from inside a
        // MatDialog. Revert to the prior z-index-based stacking so app-level
        // z-index rules apply.
        { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SchoolYearInterceptor,
            multi: true,
        },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ValidationInterceptor,
            multi: true,
        },
        { provide: Window, useValue: window },
        { provide: LoggerService, useClass: AzureLoggerService },
        { provide: LOCALE_ID, useValue: "en-US" },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    applicationInsightsService: ApplicationInsightsService,
    router: Router
  ) {
    applicationInsightsService.init(router);
  }
}
